import React from 'react';
import { useHistory } from 'react-router-dom';
import { AuthContext, AuthContextType } from '~/services';

const windowEvents = ['keydown', 'mousedown', 'touchstart'];
const timeout = 60000;

interface TimeoutListenerProps {
    services: TODO_TYPEME;
}
export function TimeoutListener({ services }: TimeoutListenerProps) {
    const { authenticated } = React.useContext(AuthContext) as AuthContextType;
    const history = useHistory();

    const hasListeners = React.useRef(false);
    const hasEventHappened = React.useRef(false);
    const historyListener = React.useRef<null | (() => void)>(null);
    const actionInterval = React.useRef<null | number>(null);

    const recordAction = () => {
        hasEventHappened.current = true;
    };

    const createListeners = React.useCallback(() => {
        const updateAction = async () => {
            if (hasEventHappened.current) {
                await services.user.updateActiveStatus();
                hasEventHappened.current = false;
            } else {
                await services.user.checkActiveStatus();
            }
        };

        if (authenticated && !hasListeners.current) {
            historyListener.current = history.listen(recordAction);
            windowEvents.forEach((x) => {
                window.addEventListener(x, recordAction);
            });
            actionInterval.current = setInterval(updateAction, timeout);
            hasListeners.current = true;
        }
    }, [authenticated, history, services.user]);

    const removeListeners = React.useCallback(() => {
        if (hasListeners.current && historyListener.current && actionInterval.current) {
            historyListener.current();
            windowEvents.forEach((x) => {
                window.removeEventListener(x, recordAction);
            });
            clearInterval(actionInterval.current);
            hasListeners.current = false;
        }
    }, []);

    React.useEffect(() => {
        createListeners();
        return () => {
            removeListeners();
        };
    }, [createListeners, removeListeners]);

    return null;
}
